export default __webpack_public_path__ + "static/media/three.8f2f54b7.png";